// extracted by mini-css-extract-plugin
export default {"linksSection":"aJ-z"};